import type { TImportDataDictionary } from "components/ImportData/type";
import type { TDefaultAutocompleteOption } from "components/shared/FormComponent/AutocompleteFormComponent";
import AutocompleteFormComponent from "components/shared/FormComponent/AutocompleteFormComponent";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import StepTitle from "../StepTitle";
import StepWrapper from "../StepWrapper";
import styles from "../style.module.scss";

interface IUpdateTypeStep {
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
    setElement: Dispatch<SetStateAction<TImportDataDictionary | undefined>>;
    options: TImportDataDictionary[];
    element: TImportDataDictionary | undefined;
}

/**
 * Step to choose which type of data to udpate (only appears conditionnaly).
 */
const UpdateTypeStep = ({ activeStep, setActiveStep, setElement, options, element }: IUpdateTypeStep) => {
    const [t] = useTranslation();

    const formatOptions = options.map((item) => ({ value: item, label: t(`BulkUpdates.DataType_${item}`) }));

    return (
        <StepWrapper activeStep={activeStep} setActiveStep={setActiveStep} conditionToDisable={!element}>
            <StepTitle title={t("BulkUpdates.TypeStep.Title")} subtitle="" />
            <div className={styles["update-select-type"]}>
                <AutocompleteFormComponent
                    options={formatOptions}
                    renderOptionText={(option: TDefaultAutocompleteOption) => option.label ?? ""}
                    fullWidth
                    label={t("BulkUpdates.TypeStep.Label")}
                    onChange={(e, data: TDefaultAutocompleteOption) => setElement(data.value)}
                    isOptionEqualToValue={(option: TDefaultAutocompleteOption, value: TDefaultAutocompleteOption) =>
                        option.value === value.value
                    }
                />
            </div>
        </StepWrapper>
    );
};

export default UpdateTypeStep;
